import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card2.scss';

class Card2 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Códigos de autorregulação são atualizados - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card2-home page-gradient page-gradient--yellow bg-gray" ref="card2-home">
          <section className="iniciativas-area card2-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Códigos de autorregulação são atualizados</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-8">
                              <p>
                                Como o mercado é dinâmico, estamos sempre atentos às práticas para manter nossa
                                autorregulação alinhada ao dia a dia das instituições e às mudanças na regulação. Por
                                conta disso, dois códigos foram atualizados em 2020. A revisão do Código de Negociação
                                de Instrumentos Financeiros foi concluída em novembro e entrou em vigor em fevereiro de
                                2021; e avançamos na revisão do Código dos Processos, que está previsto para lançamento
                                no primeiro semestre de 2021.
                              </p>
                              <p>
                                Em 2020, também iniciamos a discussão sobre a regulamentação de derivativos crossborder,
                                uma vez que a internacionalização dos mercados demandará a necessidade de ajustes tanto
                                na regulação como na autorregulação desses ativos. Esse debate continuará em 2021.
                              </p>
                              <p className="desk">
                                <b>Entenda mais sobre a revisão dos códigos:</b>
                              </p>
                            </div>
                            <div className="col-4 img-center h-img">
                              <img src={images.iniciativas.card2.img1} className="img1" />
                              <img src={images.iniciativas.card2.anima1} className="anima1" />
                              <div className="rotate-anima2">
                                <img src={images.iniciativas.card2.anima2} className="rotate anima2" />
                              </div>
                            </div>
                            <div className="col-12 mobile">
                              <p>
                                <b>Entenda mais sobre a revisão dos códigos:</b>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-6 box-2">
                  <h1 className="title">Código de Negociação de Instrumentos Financeiros</h1>
                  <p>
                    Estabelece regras para as negociações com produtos de renda fixa, derivativos de balcão e ofertas
                    públicas de distribuição de COE (Certificado de Operações Estruturadas).
                  </p>
                  <p>
                    <b>Confira as principais mudanças:</b>
                  </p>
                  <p>
                    Ênfase na conduta dos profissionais que negociam os produtos: honrar operações contratadas; praticar
                    uma comunicação clara e concisa; agir com boa-fé, diligência e lealdade; e respeitar os princípios
                    da liberdade de iniciativa e da livre concorrência.
                  </p>
                  <p>
                    Alinhamento aos outros códigos da Associação: criação de políticas sobre controles internos e/ou
                    compliance; segurança e sigilo de informações; cibersegurança; gestão de riscos e investimentos
                    pessoais dos operadores.
                  </p>
                </div>
                <div className="col-6 box-2">
                  <h1 className="title">Código dos Processos</h1>
                  <p>
                    Criado há 10 anos, define como são conduzidas as investigações e os processos por descumprimentos
                    dos nossos códigos de autorregulação, garantindo às instituições o amplo direito de defesa e a
                    agilidade nos julgamentos; estabelece os critérios para instauração de PAI (Procedimento para
                    Apuração de Irregularidades) e para celebração de termos de compromisso e aplicação de penalidades.
                    A necessidade da revisão começou a ser observada a partir de 2015, dadas as novas práticas e o
                    dinamismo de mercado. Assim, em 2020 trabalhamos na nova redação do código, que entra em março de
                    2021 em audiência pública. Entre as principais mudanças, destacam-se:
                  </p>
                  <ul>
                    <li>Fortalecimento do arcabouço regulatório e jurídico da nossa autorregulação.</li>
                    <li>
                      Maior celeridade ao processo, reduzindo a possibilidade de postergação de prazos, mas sempre
                      mantendo o direito de defesa das instituições.
                    </li>
                    <li>Diminuição de burocracias, com o acréscimo de tecnologia e inovação aos processos.</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card2 };
